export { default } from './TabsList';
export * from './TabsList.types';
export { default as tabsListClasses } from './tabsListClasses';
export * from './tabsListClasses';